"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageTypes = exports.ModalType = void 0;
var ModalType;
(function (ModalType) {
    ModalType["success"] = "success";
    ModalType["error"] = "error";
    ModalType["warning"] = "warning";
    ModalType["information"] = "information";
    ModalType["direction"] = "direction";
    ModalType["special"] = "special";
    ModalType["standout"] = "standout";
})(ModalType || (exports.ModalType = ModalType = {}));
exports.messageTypes = {
    [ModalType.success]: {
        content: { borderColor: '#608E3A' },
        header: { background: 'rgba(96,142,58,0.1)' },
        titleText: { color: "#608E3A" }
    },
    [ModalType.error]: {
        content: { borderColor: '#DE6C6C' },
        header: { background: 'rgba(222,108,108,0.1)' },
        titleText: { color: '#DE6C6C' }
    },
    [ModalType.warning]: {
        content: { borderColor: '#F0AD4E' },
        header: { background: 'rgba(240,173,78,0.1)' },
        titleText: { color: '#F0AD4E', }
    },
    [ModalType.information]: {
        content: { borderColor: '#1B75BC' },
        header: { background: 'rgba(27,117,188,0.1)' },
        titleText: { color: '#1b75bc' },
    },
    [ModalType.direction]: {
        content: { borderColor: '#9E4FA5' },
        header: { background: 'rgba(158,79,165,0.1)' },
        titleText: { color: '#9E4FA5' }
    },
    [ModalType.special]: {
        content: { borderColor: '#95C0F1' },
        header: { background: 'rgba(149,192,241,0.1)' },
        titleText: { color: '#95C0F1' }
    },
    [ModalType.standout]: {
        content: { borderColor: '#EC971F' },
        header: { background: 'rgba(236,151,31,0.1)' },
        titleText: { color: '#EC971F' }
    }
};
